export default __webpack_public_path__ + "a452a6e853418841af8710351fe461f9.ttf";